import type { GameState } from '../../engine/game-state.js';
import { createLayout, rowAbove } from '../../render/three/layout.js';
import type { GameSpec } from '../../render/three/game-app.js';
import {
  CELL_IDS,
  FOUNDATION_IDS,
  TABLEAU_IDS,
  freecellRules,
  hasAnyLegalMove,
  isAltColorDescending,
  maxSupermoveSize,
} from './rules.js';

const TABLEAU_Z = 0.0;
const TOP_Z = rowAbove(TABLEAU_Z);

const layout = createLayout({
  cols: 8,
  rows: [
    { z: TOP_Z, slots: [...CELL_IDS, ...FOUNDATION_IDS] },
    { z: TABLEAU_Z, fanDown: true, slots: [...TABLEAU_IDS] },
  ],
});

function dragStackIds(state: GameState, cardId: string): string[] {
  for (const pile of Object.values(state.piles)) {
    const idx = pile.cards.findIndex((c) => c.id === cardId);
    if (idx === -1) continue;
    if (pile.type !== 'tableau') {
      if (idx !== pile.cards.length - 1) return [];
      return [cardId];
    }
    const sequence = pile.cards.slice(idx);
    if (!isAltColorDescending(sequence)) return [];
    if (sequence.length > maxSupermoveSize(state, false)) return [];
    return sequence.map((c) => c.id);
  }
  return [];
}

export const freecellSpec: GameSpec = {
  rules: freecellRules,
  slotForPile: (id) => layout.slot(id),
  dropExclude: () => [],
  dragStackIds,
  autoSendOrder: () => [...FOUNDATION_IDS, ...TABLEAU_IDS, ...CELL_IDS],
  // Worst case: 13 tableau cards + a built run stacked on top of one column.
  maxFanLength: 19,
  statusText(state) {
    if (!hasAnyLegalMove(state)) return 'No moves left';
    return null;
  },
};
